
export type ApiV1DashboardActivitiesGet200ResponseActivitiesItem = {
  description?: string;
  id?: string;
  timestamp?: string;
  type?: string;
};
